import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@api'
import { showSuccessToast } from '@utils'
import { useLanguage } from '@context'

interface DeleteMemoryParams {
  id: string
  silent?: boolean
}

const deleteMemory = async ({ id }: DeleteMemoryParams): Promise<void> => {
  await api.delete(`/memories/${id}`)
}

export const useDeleteMemory = () => {
  const queryClient = useQueryClient()
  const { t } = useLanguage()

  return useMutation<void, Error, DeleteMemoryParams>({
    mutationFn: deleteMemory,
    onSuccess: async (_data, { silent }) => {
      if (!silent) showSuccessToast(t('toast.success'), t('toast.memoryDeleted'))
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['memories'] }),
        queryClient.invalidateQueries({ queryKey: ['myMemories'] }),
        queryClient.invalidateQueries({ queryKey: ['contact-memories'] }),
      ])
    },
  })
}
